import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4bfb44ba&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=4bfb44ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb44ba",
  null
  
)

export default component.exports